import { createAction } from 'redux-actions';

import coreApi from 'api';
import * as actions from 'constants/surveyList/SurveyListActions';
import coreActions from 'constants/actions';
import * as surveyApi from 'api/surveyList';

const { API } = coreActions;

export const mountSurveyList = createAction(actions.MOUNT_SURVEY_LIST);

export const goBackToSurveyList = createAction(actions.GO_BACK_TO_SURVEY_LIST);

export const forwardToAnalytics = createAction(actions.FORWARD_TO_ANALYTICS);

export const navigateToSurveyQuickView = createAction(actions.NAVIGATE_TO_SURVEY_QUICK_VIEW);

export const loadSurveyListPreviewOptions = createAction(
  actions.LOAD_SURVEY_LIST_PREVIEW_OPTIONS,
  (listId, text, offset, limit) => ({ listId, text, offset, limit }),
);

export const loadMoreSurveyListPreviewOptions = createAction(
  actions.LOAD_MORE_SURVEY_LIST_PREVIEW_OPTIONS,
  (listId, startIndex, stopIndex) => ({ listId, startIndex, stopIndex }),
);

export const onSurveySearch = createAction(actions.ON_SURVEY_SEARCH, (listId, text) => ({ listId, text }));

export const loadSurveyList = createAction(actions.LOAD_SURVEY_LIST, (listId, params, isShowTabsList) => ({
  listId,
  params,
  isShowTabsList,
}));

export const surveyTabChange = createAction(actions.SURVEY_TAB_CHANGE, (listId, tabName, pageNumber) => ({
  listId,
  tabName,
  pageNumber,
}));

export const sortSurveyListColumn = createAction(actions.SORT_SURVEY_LIST_COLUMN, (listId, field, order) => ({
  listId,
  field,
  order,
}));

export const toggleSurveyFavorite = createAction(
  actions.TOGGLE_SURVEY_FAVORITE,
  (listId, itemId, isFavorite) => ({ listId, itemId, isFavorite }),
);

export const changeSurveyStatus = createAction(actions.CHANGE_SURVEY_STATUS, (listId, itemId, status) => ({
  listId,
  itemId,
  status,
}));

export const changeSurveyShowInMenuValue = createAction(
  actions.CHANGE_SURVEY_SHOW_IN_MENU_VALUE,
  (listId, itemId, value) => ({ listId, itemId, value }),
);

export const setSurveyListPreviewOptions = createAction(
  actions.SET_SURVEY_LIST_PREVIEW_OPTIONS,
  (listId, options) => ({ listId, options }),
);

export const addSurveyListPreviewOptions = createAction(
  actions.ADD_SURVEY_LIST_PREVIEW_OPTIONS,
  (listId, options, offset, limit) => ({ listId, options, offset, limit }),
);

export const setSurveyListPreviewText = createAction(
  actions.SET_SURVEY_LIST_PREVIEW_TEXT,
  (listId, text) => ({ listId, text }),
);

export const setSurveyListPreviewOptionsCount = createAction(
  actions.SET_SURVEY_LIST_PREVIEW_OPTIONS_COUNT,
  (listId, count) => ({ listId, count }),
);

export const surveyListActionEdit = createAction(actions.SURVEY_LIST_ACTION_EDIT);

export const surveyListActionClone = createAction(actions.SURVEY_LIST_ACTION_CLONE);

export const surveyListActionDelete = createAction(
  actions.SURVEY_LIST_ACTION_DELETE,
  (listId, isShowTabsList) => ({
    listId,
    isShowTabsList,
  }),
);

export const surveyListActionArchive = createAction(
  actions.SURVEY_LIST_ACTION_ARCHIVE,
  (listId, isShowTabsList) => ({
    listId,
    isShowTabsList,
  }),
);

export const surveyListActionUnarchive = createAction(
  actions.SURVEY_LIST_ACTION_UNARCHIVE,
  (listId, isShowTabsList) => ({
    listId,
    isShowTabsList,
  }),
);

export const surveyListOpenDeleteModal = createAction(
  actions.SURVEY_LIST_OPEN_DELETE_MODAL,
  (listId, isShowTabsList, typeConnect, templateIds) => ({
    listId,
    isShowTabsList,
    typeConnect,
    templateIds,
  }),
);

export const surveyListOpenArchiveModal = createAction(
  actions.SURVEY_LIST_OPEN_ARCHIVE_MODAL,
  (listId, isShowTabsList, archive) => ({
    listId,
    isShowTabsList,
    archive,
  }),
);

export const patchSurveyShowInMenuValue = (listId, surveyId, value) => ({
  type: API,
  types: [
    actions.PATCH_SURVEY_SHOW_IN_MENU_REQUEST,
    actions.PATCH_SURVEY_SHOW_IN_MENU_SUCCESS,
    actions.PATCH_SURVEY_SHOW_IN_MENU_FAILURE,
  ],
  api: surveyApi.changeSurveyShowInMenuValue,
  params: [listId, surveyId, { value }],
  listId,
  value,
});

export const patchSurveyStatus = (listId, surveyId, status) => ({
  type: API,
  types: [
    actions.PATCH_SURVEY_STATUS_REQUEST,
    actions.PATCH_SURVEY_STATUS_SUCCESS,
    actions.PATCH_SURVEY_STATUS_FAILURE,
  ],
  api: surveyApi.changeSurveyStatus,
  params: [surveyId, { status }],
  listId,
  status,
});

export const postCloneSurvey = (listId, ...rest) => ({
  type: API,
  types: [
    actions.POST_CLONE_SURVEY_REQUEST,
    actions.POST_CLONE_SURVEY_SUCCESS,
    actions.POST_CLONE_SURVEY_FAILURE,
  ],
  api: surveyApi.cloneSurvey,
  params: rest,
  listId,
});

export const getSurveyListPreviewOptions = (listId, reset, ...rest) => ({
  type: API,
  types: [
    actions.GET_SURVEY_LIST_PREVIEW_OPTIONS_REQUEST,
    actions.GET_SURVEY_LIST_PREVIEW_OPTIONS_SUCCESS,
    actions.GET_SURVEY_LIST_PREVIEW_OPTIONS_FAILURE,
  ],
  api: surveyApi.getSurveysNames,
  params: rest,
  listId,
  reset,
});

export const deleteSurvey = (listId, api, itemIds, isShowTabsList, ...rest) => ({
  type: API,
  types: [actions.DELETE_SURVEY_REQUEST, actions.DELETE_SURVEY_SUCCESS, actions.DELETE_SURVEY_FAILURE],
  api,
  params: rest,
  listId,
  itemIds,
  isShowTabsList,
});

export const batchSurveysStatus = (listId, itemIds, isShowTabsList, ...rest) => {
  return {
    type: API,
    types: [
      actions.BATCH_SURVEYS_STATUS_REQUEST,
      actions.BATCH_SURVEYS_STATUS_SUCCESS,
      actions.BATCH_SURVEYS_STATUS_FAILURE,
    ],
    api: coreApi.bulk,
    params: rest,
    listId,
    itemIds,
    isShowTabsList,
  };
};

export const postCreateSurvey = (options = { shouldReplaceLocation: false }, ...rest) => ({
  type: API,
  types: [
    actions.POST_CREATE_SURVEY_REQUEST,
    actions.POST_CREATE_SURVEY_SUCCESS,
    actions.POST_CREATE_SURVEY_FAILURE,
  ],
  api: surveyApi.createSurvey,
  params: rest,
  shouldReplaceLocation: options.shouldReplaceLocation,
});
